import React, {useState, useEffect, useCallback} from 'react';
import './VehicleForm.css'
import { Container, Row } from 'react-bootstrap';
import { Formik, Form, Field } from 'formik';
import { PickerOverlay } from 'filestack-react';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';

import axios from 'axios';

function VehicleForm(){

    const [vehicleMakeData, setVehicleMakeData] = useState([])
    const [vehicleModelData, setVehicleModelData] = useState([])
    const [vehicleImgURL, setImgURL] = useState('https://www.kindpng.com/picc/m/296-2969971_clip-art-of-car-clipart-image-black-and.png')
    const [MakeID , setMakeID] = useState()
    const [buttonToggle, setButtonToggle] = useState(false)

    const Colors = ["Red", "Blue", "Green", 
    "Black", "White", "Gray", 
    "Purple", "Yellow", "Gold", 
    "Silver", "N/A"]

    const Conditions = ["Good", "Fair", "Poor"]

    const fetchModelID = useCallback(async () => {
        let response = await fetch(`${FetchVariable.Heroku}/models/${MakeID}/model`)
        response = await response.json()
        setVehicleModelData(response);
    }, [MakeID])

    useEffect(() => {
        fetch([`${FetchVariable.Heroku}/makes`])
          .then(response => response.json())
          .then(data => {
            setVehicleMakeData(data);
          })
          .catch(err => console.log(err));
      }, []); // eslint-disable-line

    useEffect(() => {
        fetchModelID()
    },[fetchModelID]); // eslint-disable-line

    function postVehicle(payload){
        if(payload){
            axios.post(`${FetchVariable.Heroku}/vehicles/new-vehicle`, payload)
            .catch(err => {
                console.log(err)
            })
        }
    }

    const VehicleMakeData = () => {
        if(vehicleModelData){
            return(
            <Row>
            <label className="vehicleMakeLabel" htmlFor="MakeID">Make</label>
            <Field className="vehicleMakeOption" as="select" id="MakeID" name="MakeID" onBlur={e => setMakeID(e.target.value)} onSubmit={fetchModelID}>
            <option disabled value="">Manufacturer</option>
                {vehicleMakeData?.map(Make => 
                <option value={Make.MakeID} key={Make.MakeID}>{Make.Make}</option>)}
            </Field>
            </Row>
            )
        }else{
            return (
            null
            )
        }
    }

    const VehicleModelData = () => {
        if(vehicleModelData){
            return(
                <Row>
                <label className="vehicleModelLabel" htmlFor="ModelID">Model</label>
                    <Field className="vehicleModelOption" as="select" id="ModelID" name="ModelID">
                        <option disabled value="">Select Make First</option>
                        {vehicleModelData?.map(Model => 
                        <option value={Model.ModelID} key={Model.ModelID}>{Model.Model}</option>)}
                    </Field>
            </Row>
            )
        }else{
            return (
            null
            )
        }
    }

    const ImagePicker = () => {
        if(buttonToggle){
            return(

                <PickerOverlay
                pickerOptions={{
                    onClose: () => {setButtonToggle(false)}
                    }}
                onError={(error) => console.log(error)}
                apikey={"AleCal6RpTNa6OEcJpvEQz"}
                onSuccess={() => setButtonToggle(false)}
                onUploadDone={(res) => setImgURL(res.filesUploaded[0].url)}
                />
            )
        }else{
            return(
                null
            )
        }
    }

    function makeYearOptions(){

        var years = [];
        let maximumYear = (new Date().getFullYear() + 1)

        for (let i = 1950; i <= maximumYear; i++){
            years.push(<option key={i} value={i}>{i}</option>)
        }
        return years
    }
    
    return (
        <Formik
          initialValues={{
            MakeID: '',
            ModelID: '',
            VehicleStatus: '',
            VehicleColor: '',
            VehicleMPG: '',
            VehicleMiles: '',
            VehicleYear: '',
            VehicleCondition: '',
            VehicleVIN: '',
            ImageURL: '',
            PurchasePrice: '',
            PurchaseDate: '',
            SalesPrice: '',
          }}

          onSubmit={async (values, { resetForm }) => {
            await new Promise((r) => setTimeout(r, 500));
            values.ImageURL = vehicleImgURL
            let payload = values;
            postVehicle(payload);
            resetForm();
          }}

        >
        <div className="container">
          <Form>
              <h1 className='vehicleFormH1'>New Vehicle Form</h1>
              <hr className="solid"></hr>
          <Container className="vehicleMakeModel">
                <VehicleMakeData />
                <VehicleModelData />
            <Row>
                <label className="vehicleYearLabel">
                    Vehicle Year
                    </label>
                    <Field className="vehicleYearOption" as="select" id="VehicleYear" name="VehicleYear">
                        {makeYearOptions()}
                    </Field>
            </Row>
            <hr className="solid"></hr>
            </Container>
            <h2 className="vehicleConditionH2">Vehicle Condition</h2>
            <label className="vehicleRepairLabel">
              <Field className="vehicleRepairRadio" type="radio" name="VehicleStatus" value="Repair" />
              Needs Repair
            </label>
            <label className="vehicleSaleLabel">
              <Field className="vehicleSaleRadio" type="radio" name="VehicleStatus" value="ForSale" />
              For Sale
            </label>
            <label className="vehicleSaleLabel">
              <Field className="vehicleSaleRadio" type="radio" name="VehicleStatus" value="Arriving" />
              Arriving from Vendor
            </label>
            <label className="vehicleSaleLabel">
              <Field className="vehicleSaleRadio" type="radio" name="VehicleStatus" value="N/A" />
              N/A
            </label>

            <div className="col-md-6 vehicleColorContainer">
                <label className="vehicleColorLabel" htmlFor="VehicleColor">Vehicle Color</label>
                    <Field className="vehicleColorField" as="select" id="VehicleColor" name="VehicleColor">
                        <option disabled value="">Select Color</option>
                            {Colors?.map(Color => 
                        <option key={Color} value={Color}>{Color}</option>)}
                    </Field>
            </div>

            <div className="col-md-6 vehicleConditionContainer">
                <label className="col-md-6 vehicleConditionLabel">
                    Vehicle Status
                </label>
                <Field as="select" className="vehicleConditionOption" id="VehicleCondition" name="VehicleCondition">
                    <option disabled value="">Select Condition</option>
                        {Conditions?.map(Condition => 
                    <option key={Condition} value={Condition}>{Condition}</option>)}
                </Field>
            </div>
            <hr className="solid"></hr>
            <div className="col-md-7 col-lg-8">
                <h4 className="mb-3 mt-3 vehicleInformationHeader">Vehicle Information</h4>
                    <div className="row g-4">
                        <div className="col-sm-6">
                            <label className="vehicleMPGLabel">
                                Vehicle MPG
                            </label>
                                <Field className="vehicleMPGInput" as="input" type="number" id="VehicleMPG" name="VehicleMPG" placeholder="00.0"/> 
                        </div>

                        <div className="col-6">
                        <label className="vehicleMilesLabel">
                                Vehicle Miles
                            </label>
                                <Field className="vehicleMilesInput" as="input" type="number" id="VehicleMiles" name="VehicleMiles" placeholder="Miles"/>
                        </div>

                        <div className="col-6">
                            <label className="vehicleVINLabel">
                                Vehicle VIN
                                </label>
                                <Field className="vehicleVINInput" as="input" id="VehicleVIN" name="VehicleVIN" minLength="17" maxLength="17" placeholder="VIN Number"/> 
                        </div>

                        <div className="col-6">
                            <label className="vehiclePriceLabel">
                                Purchase Price
                                </label>
                                <Field className="vehiclePriceInput" as="input" type="number" id="PurchasePrice" name="PurchasePrice" placeholder="$0000.00"/>   
                        </div>

                        <div className="col-6">
                            <label className="vehiclePurchaseLabel">
                                Purchase Date
                            </label>
                                <Field className="vehiclePurchaseInput" as="input" type="date" id="PurchaseDate" name="PurchaseDate"/>   
                        </div>

                        <div className="col-6">
                            <label className="vehicleMPGLabel">
                                Sales Price
                            </label>
                                <Field className="vehicleSalesField" as="input" type="number" id="SalesPrice" name="SalesPrice" placeholder="$0000.00"/>   
                        </div>
                </div>
            </div>
            <hr className="solid"></hr>
            <div className="vehicleImgContainer"> <h1>Vehicle Image</h1>

            <button type="button" onClick={() => setButtonToggle(true)}>Vehicle Image Upload</button>
                    <ImagePicker />
            </div>

                <button className="button-44" type="submit">
                        Submit New Vehicle
                </button>
                <div>&nbsp;</div>

          </Form>
          </div>
        </Formik>

    );
}

export default VehicleForm;
